import { map, find } from 'lodash';

class UpgradeFormController {
  constructor($rootScope, eventsService, upgradeService, imgix, messageService) {
      this.$rootScope = $rootScope;
      this.eventsService = eventsService;
      this.upgradeService = upgradeService;
      this.imgix = imgix;
      this.messageService = messageService;
  }

  $onInit(){
      this.loading = true;
      if ( !this.collection ) {
        this.eventsService.collectGrouped().then(response => {
          this.collection = response;
          this.loading = false;
          if (this.source.upgrades && this.source.upgrades[0]) {
            this.source.upgrades[0].upgrade = find(this.collection[this.source.type_name], { id : this.source.upgrades[0].upgrade_id});
          }
        });
      } else {
        this.loading = false;
      }
      this.imgix.reload();
  }

  upgradeSelected()
  {
    return this.source.upgrades[0].upgrade;
  }

  upgradeIsSpaDay()
  {
    if (this.upgradeSelected()) {
      return this.source.upgrades[0].upgrade.type_name === 'SpaDay';
    }
  }

  onSave(){
      let dispatch = {
        'origin_type': this.source.type_raw,
        'origin_id': this.source.id,
        'upgrades': map(this.source.upgrades, upgrade => {
          return {'id': upgrade.id || undefined, 'upgrade_type': upgrade.upgrade.type_raw, 'upgrade_id': upgrade.upgrade.id}; })
      };

      return this.upgradeService.save(dispatch)
        .catch(() => {
          this.messageService.failure('The upgrade could not be updated');
          this.messageService.push();
        })
        .then(() => {
          this.messageService.success('The upgrade has been successfully updated');
          switch (this.source.type_name){
              case 'SpaDay':
                  this.formTab = 'day';
                  break;
              case 'Treatment':
                  this.formTab = 'treatment';
                  break;
          }
          this.messageService.push();
        });
  }

  removeUpgrade() {
    this.source.upgrades = [];
  }

  selectEvent() {
    setTimeout(() => {this.imgix.reload();});
  }

  price(){
    return Math.floor(this.source.upgrades[0].upgrade.base_price);
  }
}

UpgradeFormController.$inject = [ '$rootScope', 'eventsService', 'upgradeService', 'imgix', 'messageService' ];

export default UpgradeFormController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/upgrade/controllers/upgrade.form.controller.js